class FreeShippingPopup extends HTMLElement {
	constructor() {
		super();
		this.inner = this.querySelector(".free-shipping-popup__inner");
		this.cartDrawer = document.querySelector("cart-drawer");
	}

	connectedCallback() {
		if (typeof subscribe === "function") {
			this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () =>
				this.refresh()
			);
		}

		if (this.cartDrawer) {
			this.drawerObserver = new MutationObserver(() => this.updateVisibility());
			this.drawerObserver.observe(this.cartDrawer, {
				attributes: true,
				attributeFilter: ["class"],
			});
		}

		this.updateVisibility();
	}

	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
		if (this.drawerObserver) this.drawerObserver.disconnect();
	}

	get drawerOpen() {
		return this.cartDrawer
			? this.cartDrawer.classList.contains("active")
			: false;
	}

	get hasContent() {
		return !!this.querySelector(".free-shipping-bar");
	}

	updateVisibility() {
		this.hidden = this.drawerOpen || !this.hasContent;
	}

	refresh() {
		const root =
			(window.Shopify &&
				window.Shopify.routes &&
				window.Shopify.routes.root) ||
			"/";
		const sectionId = this.dataset.sectionId;
		if (!sectionId) return;

		const overlay = this.querySelector(".free-shipping-bar > .loading-overlay");
		if (overlay) overlay.classList.remove("hidden");

		fetch(`${root}?section_id=${encodeURIComponent(sectionId)}`)
			.then((response) => response.text())
			.then((text) => {
				const html = new DOMParser().parseFromString(text, "text/html");
				const newInner = html.querySelector(".free-shipping-popup__inner");
				if (newInner && this.inner) {
					this.inner.innerHTML = newInner.innerHTML;
				}
				this.updateVisibility();
			})
			.catch((e) => {
				console.error(e);
				if (overlay) overlay.classList.add("hidden");
			});
	}
}

customElements.define("free-shipping-popup", FreeShippingPopup);
